"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragAndDropContext = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.DragAndDropContext = React.createContext({
    availableItems: [],
    permittedActions: {
        createTab: true,
        editTabName: true,
        dragAndDropTab: true,
        deleteTab: true,
    },
});
